import Select from 'react-select';
import './CustomerList.css';
import React from 'react';

const CustomersDropdown = (props) => {
  const { data = [], reset } = props;
  const dataForCustomerOptions = [];

  const attributes = {
    ...props,
    classNamePrefix: 'customer',
    options: dataForCustomerOptions,
    isMulti: true,
  };

  if (reset) {
    attributes.value = null;
  }

  // eslint-disable-next-line
  data.map((customer) => {
    if (customer.value !== '') {
      dataForCustomerOptions.push({ value: customer.value, label: customer.value });
    }
  });
  return (
    <div className="customer-dropdown-container">
      <Select {...attributes} />
    </div>
  );
};

export default CustomersDropdown;



// WEBPACK FOOTER //
// ./src/components/search/CustomerSearch/CustomersDropdown.js